<template>
  <div class="resume-section experience-section">
    <h2 class="section-heading" :style="headingStyle">Experience</h2>
    <div v-for="(item, index) in section.data.items" :key="index" class="entry">
      <div class="entry-header">
        <div>
          <h3 class="entry-title">{{ item.title || 'Job Title' }}</h3>
          <p class="entry-org">{{ item.company || 'Company Name' }}</p>
        </div>
        <div class="entry-meta">
          <p>{{ item.startDate || 'Start' }} – {{ item.endDate || 'End' }}</p>
          <p v-if="item.location">{{ item.location }}</p>
        </div>
      </div>
      <ul class="entry-list">
        <li v-for="(desc, idx) in item.description" :key="idx" v-if="desc">
          {{ desc }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#0f766e'
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headingStyle() {
      return {
        color: this.themeColor,
        borderColor: this.themeColor,
      }
    }
  }
}
</script>

<style scoped>
.section-heading {
  font-family: var(--ps-font-display);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-bottom: 2px solid;
  padding-bottom: 0.45rem;
  margin-bottom: 1rem;
}

.entry + .entry {
  margin-top: 1.15rem;
}

.entry-header {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.45rem;
}

@media (min-width: 640px) {
  .entry-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
  }
}

.entry-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.entry-org {
  font-size: 0.95rem;
  color: #475569;
  font-weight: 500;
}

.entry-meta {
  font-size: 0.8rem;
  color: #64748b;
  text-align: left;
  white-space: nowrap;
}

@media (min-width: 640px) {
  .entry-meta {
    text-align: right;
  }
}

.entry-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.entry-list li {
  position: relative;
  padding-left: 1rem;
  margin-bottom: 0.3rem;
  color: #334155;
  font-size: 0.9rem;
  line-height: 1.55;
}

.entry-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.55em;
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 9999px;
  background: color-mix(in srgb, var(--resume-accent, #0f766e) 70%, #94a3b8);
}
</style>
